import { passkeyClient } from "@better-auth/passkey/client";
import { organizationClient, deviceAuthorizationClient } from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";
import { API_URL } from "./api-client";

export const authClient = createAuthClient({
  baseURL: API_URL,
  plugins: [organizationClient({ teams: { enabled: true } }), passkeyClient(), deviceAuthorizationClient()],
});
